import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from './globals';
import { ConnectedEmail } from 'app/models/connected-email';

@Injectable({
  providedIn: 'root'
})
export class ConnectedEmailService {
  private baseUrl: string;

  constructor(private httpClient: HttpClient, private globals: Globals) {
    this.baseUrl = `${this.globals.api_base_url}/connected-emails`;
  }

  getAll(): Observable<ConnectedEmail[]> {
    return this.httpClient.get<ConnectedEmail[]>(`${this.baseUrl}`);
  }

  getOne(id: number): Observable<ConnectedEmail> {
    return this.httpClient.get<ConnectedEmail>(`${this.baseUrl}/${id}`);
  }

  getFolders(ids: number[]): Observable<string[]> {
    if (ids.length == 0) return new Observable<string[]>(observer => observer.next([]));
    
    return this.httpClient.get<string[]>(`${this.baseUrl}/${ids.join(',')}/folders`);
  }

  create(data: ConnectedEmail): Observable<ConnectedEmail> {
    return this.httpClient.post<ConnectedEmail>(`${this.baseUrl}`, data);
  }

  update(id: number, data: ConnectedEmail): Observable<ConnectedEmail> {
    return this.httpClient.put<ConnectedEmail>(`${this.baseUrl}/${id}`, data);
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/${id}`);
  }
}
